import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft, PawPrint, Search } from 'lucide-react';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="text-center max-w-md"
      >
        {/* 404 Görsel */}
        <div className="relative w-32 h-32 mx-auto mb-6">
          <motion.div
            animate={{ rotate: [0, -10, 10, -10, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
            className="absolute inset-0 flex items-center justify-center"
          >
            <PawPrint className="w-20 h-20 text-teal-200" strokeWidth={1.5} />
          </motion.div>
          <div className="relative w-32 h-32 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-3xl flex items-center justify-center shadow-xl shadow-teal-300/40">
            <span className="text-5xl font-black text-white">404</span>
          </div>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Sayfa Bulunamadı
        </h1>
        <p className="text-sm text-gray-500 mb-8">
          Aradığınız sayfa taşınmış veya hiç olmamış olabilir. Hadi sizi güvenli bir yere götürelim.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-secondary inline-flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Geri Dön
          </button>
          <Link to="/app" className="btn btn-primary inline-flex items-center gap-2">
            <Home className="w-4 h-4" />
            Ana Sayfa
          </Link>
        </div>

        {/* Hızlı linkler */}
        <div className="mt-10 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-400 mb-3">Hızlı erişim</p>
          <div className="flex flex-wrap gap-2 justify-center">
            <Link to="/app/owners" className="text-xs text-teal-600 hover:text-teal-700 font-medium inline-flex items-center gap-1">
              <Search className="w-3 h-3" /> Hayvan Sahipleri
            </Link>
            <span className="text-gray-300">·</span>
            <Link to="/app/pets" className="text-xs text-teal-600 hover:text-teal-700 font-medium inline-flex items-center gap-1">
              <Search className="w-3 h-3" /> Hastalar
            </Link>
            <span className="text-gray-300">·</span>
            <Link to="/app/appointments" className="text-xs text-teal-600 hover:text-teal-700 font-medium inline-flex items-center gap-1">
              <Search className="w-3 h-3" /> Randevular
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
